import React from 'react'

import Tooltip from './tooltip'

/**
 * A function similar to a HOC but instead of passing in a Component only a React element is passed in.
 * @example <caption>Basic example</caption>
 * <code>
 * const DivWithTooltip = withTooltip(<div>Hello</div>, 'World')
 * ...
 * <DivWithTooltip />
 * ...
 * </code>
 * @param {*} element - React element which should be wrapped by the tooltip (https://reactjs.org/docs/rendering-elements.html)
 * @param {*} tooltipContent - tooltip content (Text or React element)
 * @returns A React React component either with tooltip (if tooltip content is set ) or without
 */
export function withTooltip(element, tooltipContent) {
    if (!tooltipContent || (typeof tooltipContent === 'string' && tooltipContent.length < 1)) {
        return () => element
    }

    return () => <Tooltip content={tooltipContent}>{element}</Tooltip>
}
